import { OrderService } from './../../../services/order.service';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { Component, Inject, OnInit, ViewEncapsulation } from '@angular/core';
import { CancelationPayload, CancelMotive } from '@models/cancel-motive.model';
import { TranslateModule } from '@ngx-translate/core';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatButtonModule } from '@angular/material/button';
import { FormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';


@Component({
  selector: 'app-cancel-confirmation-modal',
  templateUrl: './cancel-confirmation-modal.component.html',
  encapsulation: ViewEncapsulation.None,
  standalone: true,
  imports: [
    MatIconModule,
    MatDialogModule,
    FormsModule,
    MatButtonModule,
    MatFormFieldModule,
    MatProgressSpinnerModule,
    TranslateModule
],
})
export class CancelConfirmationModalComponent implements OnInit {
  public confirmationStep = false;
  public screen: string;
  public order: any;
  public isPAD: boolean;
  public isCancelable: boolean;
  public isPickup: boolean;
  public comments: string;
  public motiveSelected: number;
  public motiveList: CancelMotive[] = [];
  public loading = false;



  constructor(
    private dialogRef: MatDialogRef<CancelConfirmationModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private orderService: OrderService
  ) { }

  ngOnInit(): void {
    this.order = this.data?.order;
    this.isPAD = this.data?.isPAD;
    this.isCancelable = this.data?.isCancelable;
    this.isPickup = this.data?.isPickup;
    this.motiveList = this.data?.cancelMotives;
    this.checkOrder();
  }



  public checkOrder() {
    if (this.isCancelable) {
      this.screen = 'step1';
    } else {
      this.screen = 'cantCancel';

    }
  }

  public closeModal(status: string): void {
    this.dialogRef.close(status);
  }

  public async cancelOrder(): Promise<void> {
    try {
      this.loading = true;
      const payload: CancelationPayload = { 'motive_id': this.motiveSelected, 'comment': this.comments };
      const { data } = await this.orderService.cancelOrder(this.order.order_id, payload);
      switch (data.message) {
        case 'Order successfully canceled.':
          this.dialogRef.close('deleted');
          break;
        case 'Order is already canceled or is not possible to cancel it.':
          this.dialogRef.close('already_deleted');
          break;
        default:
          this.dialogRef.close('error');
          break;
      }
    } catch (error) {
      this.dialogRef.close('error');
    }
  }

  public nextStep() {
    this.screen = 'step2';
  }
  public prevStep() {
    this.screen = 'step1';

  }

}
